import request from '@/utils/request'

const APP_ID = process.env.VUE_APP_WECHAT_APPID

/**
 * 获取微信授权URL
 * @param {string} redirectUri - 授权后重定向的回调链接地址
 * @param {string} state - 重定向后会带上state参数，开发者可以填写a-zA-Z0-9的参数值，最多128字节
 * @returns {string} 微信授权URL
 */
export function getWechatAuthUrl(redirectUri, state = 'STATE') {
  const encodedRedirectUri = encodeURIComponent(redirectUri)
  return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx8367c516f7427d2c&redirect_uri=${encodedRedirectUri}&response_type=code&scope=snsapi_base&state=${state}#wechat_redirect`
}

/**
 * 从URL中获取code参数
 * @returns {string|null} code参数
 */
export function getCodeFromUrl() {
  const urlParams = new URLSearchParams(window.location.search)
  return urlParams.get('code')
}

/**
 * 检查当前是否在微信环境中
 * @returns {boolean}
 */
export function isWechatBrowser() {
  const ua = navigator.userAgent.toLowerCase()
  return ua.includes('micromessenger')
}

/**
 * 发起微信静默授权
 * @param {string} redirectUri - 授权后重定向地址
 */
export function wechatSilentAuth(redirectUri) {
  if (!isWechatBrowser()) {
    console.warn('当前不在微信环境中')
    return false
  }

  const authUrl = getWechatAuthUrl(redirectUri)
  window.location.href = authUrl
  return true
}

/**
 * 使用code换取openid并登录
 * @param {string} code - 微信授权code
 * @returns {Promise}
 */
export async function loginWithCode(code) {
  try {
    const response = await request({
      url: '/wx/silentLogin',
      method: 'post',
      data: { code }
    })
    return response.data
  } catch (error) {
    throw error
  }
}

/**
 * 清除URL中的code和state参数
 */
export function clearAuthParams() {
  const url = new URL(window.location.href)
  url.searchParams.delete('code')
  url.searchParams.delete('state')
  window.history.replaceState({}, document.title, url.toString())
}
